export type ErrorCode =
  | "AUDIO_UNAVAILABLE"
  | "AUDIO_DECODE_FAILED"
  | "MIDI_UNSUPPORTED"
  | "MIDI_DENIED"
  | "MIDI_INSECURE_CONTEXT"
  | "MIDI_ERROR"
  | "PROJECT_INVALID"
  | "PROJECT_TOO_LARGE"
  | "PROJECT_UNSUPPORTED_VERSION"
  | "PROJECT_CONFLICT"
  | "NOT_FOUND"
  | "FILE_TOO_LARGE"
  | "FILE_INVALID"
  | "STORAGE_ERROR"
  | "SINK_UNSUPPORTED"
  | "SINK_FAILED"
  | "SOUND_LOAD_FAILED"
  | "SOUND_UNKNOWN";

/** Application error with a machine-readable code (AGENT.md §20). */
export class AppError extends Error {
  readonly code: ErrorCode;
  constructor(code: ErrorCode, message: string, options?: { cause?: unknown }) {
    super(message, options);
    this.name = "AppError";
    this.code = code;
  }
}

export function errorMessage(err: unknown): string {
  if (err instanceof Error) return err.message;
  return String(err);
}
